import { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  Paper,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useLocation, useNavigate } from 'react-router';
import '../Customer/CustomerScreens.scss';

export default function AddAddress() {
  const navigate = useNavigate();
  const location = useLocation();
  const [formValues, setFormValues] = useState({
    label: 'Home',
    fullName: '',
    mobile: '',
    house: '',
    area: '',
    city: '',
    state: '',
    pincode: '',
  });

  const handleFieldChange = (field) => (event) => {
    setFormValues((current) => ({
      ...current,
      [field]: event.target.value,
    }));
  };

  const handleSave = () => {
    const addressParts = [
      formValues.house,
      formValues.area,
      formValues.city,
      formValues.state,
      formValues.pincode,
    ].filter(Boolean);

    const newAddress = {
      id: `address_${Date.now()}`,
      label: formValues.label || 'New Address',
      address: addressParts.join(', ') || 'Address not provided',
      fullName: formValues.fullName || 'Guest User',
      mobile: formValues.mobile || '',
    };

    navigate(location.state?.from || '/checkout', {
      state: {
        newAddress,
        selectedAddressId: newAddress.id,
      },
    });
  };

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Add Address</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        <Paper className='customer-card' sx={{ p: 2.25 }}>
          <Stack className='customer-formGrid'>
            <TextField
              fullWidth
              select
              label='Address type'
              value={formValues.label}
              onChange={handleFieldChange('label')}
            >
              <MenuItem value='Home'>Home</MenuItem>
              <MenuItem value='Office'>Office</MenuItem>
              <MenuItem value='Family'>Family</MenuItem>
              <MenuItem value='Other'>Other</MenuItem>
            </TextField>
            <TextField
              fullWidth
              label='Full name'
              placeholder='Enter receiver name'
              value={formValues.fullName}
              onChange={handleFieldChange('fullName')}
            />
            <TextField
              fullWidth
              label='Mobile number'
              placeholder='Enter mobile number'
              value={formValues.mobile}
              onChange={handleFieldChange('mobile')}
            />
            <TextField
              fullWidth
              label='House / Flat / Building'
              placeholder='Flat no, house name'
              value={formValues.house}
              onChange={handleFieldChange('house')}
            />
            <TextField
              fullWidth
              label='Area / Street'
              placeholder='Street, colony, landmark'
              value={formValues.area}
              onChange={handleFieldChange('area')}
            />
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
              <TextField
                fullWidth
                label='City'
                placeholder='City'
                value={formValues.city}
                onChange={handleFieldChange('city')}
              />
              <TextField
                fullWidth
                label='State'
                placeholder='State'
                value={formValues.state}
                onChange={handleFieldChange('state')}
              />
            </Stack>
            <TextField
              fullWidth
              label='Pincode'
              placeholder='Postal / zip code'
              value={formValues.pincode}
              onChange={handleFieldChange('pincode')}
            />
            <Button
              className='customer-actionButton customer-actionButton--primary'
              onClick={handleSave}
            >
              Save Address
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Box>
  );
}
